import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-card product-card-coupon" }
const _hoisted_2 = { class: "coupon-card-header" }
const _hoisted_3 = { class: "coupon-inner" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "product-image" }
const _hoisted_6 = { class: "product-body" }
const _hoisted_7 = {
  key: 0,
  class: "coupon-savings"
}
const _hoisted_8 = {
  key: 1,
  class: "coupon-expiry"
}

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { format, parseISO } from 'date-fns';
import WCImage from '@/components/WCImage/WCImage.vue';
import WCCouponClipButtonModern from '@/components/WCCouponClipButtonModern/WCCouponClipButtonModern.vue';
import useCoupon from '@/modules/coupons/composables/useCoupon';
import ExternalCoupon from '@/models/entities/items/external-coupon';

interface Props {
  coupon: ExternalCoupon;
  couponFilter?: string;
  savingsText?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCDigitalCouponCardModern',
  props: {
    coupon: {},
    couponFilter: {},
    savingsText: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const {
  handleClip,
  evaluateClipStatus,
  evaluateRedeemedStatus,
  openMoreInfoModal,
  couponTitle,
} = useCoupon(props.coupon);

const expiryText = computed(() => {
  if (!props.coupon.endDate) {
    return null;
  }
  const isoDate = parseISO(props.coupon.endDate);
  return isoDate instanceof Error ? null : format(isoDate, 'M/d/yy');
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('coupon')), 1),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "coupon-dismiss",
        type: "button",
        "aria-label": _unref(t)('moreOptions'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openMoreInfoModal)(_ctx.couponFilter)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "ellipsis-vertical",
          "aria-hidden": "true"
        })
      ], 8, _hoisted_4),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(WCImage, {
          imageSrc: _ctx.coupon.imageUrl || '',
          imageAlt: _ctx.coupon.name,
          defaultTitle: _ctx.coupon.name
        }, null, 8, ["imageSrc", "imageAlt", "defaultTitle"])
      ]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: `/b?g=BRD-${_ctx.coupon.brand}`,
          "aria-label": `Brand ${_ctx.coupon.brand}`,
          class: "product-brand link-dark underline-link-from-center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.coupon.brand), 1)
          ]),
          _: 1
        }, 8, ["to", "aria-label"]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (_ctx.savingsText || _unref(couponTitle))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.savingsText || _unref(couponTitle)), 1))
          : _createCommentVNode("", true),
        _cache[2] || (_cache[2] = _createTextVNode()),
        (expiryText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('exp')) + ": " + _toDisplayString(expiryText.value), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createVNode(WCCouponClipButtonModern, {
        couponId: _ctx.coupon.id,
        availableLabel: _unref(t)('clip'),
        clippedLabel: _unref(t)('clippedCoupon'),
        redeemedLabel: _unref(t)('couponRedeemed'),
        couponFilter: _ctx.couponFilter,
        disabled: false,
        isClipped: _unref(evaluateClipStatus),
        isRedeemed: _unref(evaluateRedeemedStatus),
        handleClip: _unref(handleClip)
      }, null, 8, ["couponId", "availableLabel", "clippedLabel", "redeemedLabel", "couponFilter", "isClipped", "isRedeemed", "handleClip"])
    ])
  ]))
}
}

})